<template>
  <div class="mt-[16px] px-[8px] mx-auto flex-y-center justify-between">
    <div class="flex-y-center text-font-1 flex-1 gap-[2px]">
      <span class="text-[12px] text-font-40 mr-[10px]">{{
        $t('da-jia-du-zai-sou')
      }}</span>
      <div
        class="flex-y-center flex-1 gap-[15px] h-[13px] flex-wrap overflow-hidden"
      >
        <a
          v-for="item in popularList?.data"
          :key="item"
          class="text-font-1 text-[12px]"
          @click="chooseKey(item)"
        >
          {{ item }}
        </a>
      </div>
      <!-- </template> -->
    </div>
    <!-- <a
      v-if="area === SEARCH_RECORD_UNIQUE.HELP_CENTER"
      class="flex-y-center cursor-pointer gap-[4px] text-font-60 hover:text-primary"
      @click="popularRefresh"
    >
      <iconpark-icon name="reset-circle" size="16" />{{ $t('huan-yi-huan') }}
    </a> -->
    <a
      class="flex-y-center cursor-pointer gap-[4px] text-font-40 text-[12px]"
      @click="popularRefresh"
    >
      <iconpark-icon name="arrow-refresh" size="16" />{{ $t('huan-yi-huan') }}
    </a>
  </div>
</template>

<script setup lang="ts">
import Popular from './popular.vue'
import { getSiteHotWord } from '~/api/module/search'
import { SEARCH_HOT_WORD, SEARCH_RECORD_UNIQUE } from '~/constants/index'

const emits = defineEmits(['select'])
const props = defineProps<{
  area: SEARCH_RECORD_UNIQUE
  source?: SOURCE
}>()

const hotAction = {
  // [SEARCH_RECORD_UNIQUE.TEMPLATE]: getTemplateHotWord,
  // [SEARCH_RECORD_UNIQUE.CHARACTER]: get3DHotWord,
  [SEARCH_RECORD_UNIQUE.SITE]: getSiteHotWord,
  [SEARCH_RECORD_UNIQUE.HELP_CENTER]: getSiteHotWord,
}

// 对应埋点source
const trackSource = {
  [SEARCH_RECORD_UNIQUE.TEMPLATE]: SOURCE.TEMPLATE_CENTER,
  [SEARCH_RECORD_UNIQUE.CHARACTER]: SOURCE.CHARACTER,
  [SEARCH_RECORD_UNIQUE.SITE]: SOURCE.SITE_SEARCH,
  [SEARCH_RECORD_UNIQUE.HELP_CENTER]: SOURCE.HELP_CENTER,
}

const { data: popularList, refresh: popularRefresh } = useAsyncData(() =>
  getSiteHotWord(
    props.area === SEARCH_RECORD_UNIQUE.SITE
      ? SEARCH_HOT_WORD.SITE
      : SEARCH_HOT_WORD.HELP,
    8
  )
)

const chooseKey = (key: string) => {
  trackEvent(TRACK_EVENT.CLICK_HOT_KEYWORD_SEARCH, {
    source: props.source || trackSource[props.area],
    keywords: key,
  })
  emits('select', key)
}
</script>
